export enum OperationsAcronymsEnum {
    NOVO = 'novo',
    REFIN = 'refin',
}